import { cva } from "class-variance-authority"

export const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        success:
          "border-transparent bg-success text-success-foreground hover:bg-success/90",
        warning:
          "border-transparent bg-warning text-warning-foreground hover:bg-warning/90",
        info:
          "border-transparent bg-info text-info-foreground hover:bg-info/90",
        outline: "text-foreground",
        lead:
          "border-transparent bg-orange-100 text-orange-700 hover:bg-orange-200",
        customer:
          "border-transparent bg-green-100 text-green-700 hover:bg-green-200",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)